import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private readonly ADMIN_USER_ID = 'AdminUserId';
  private readonly USER_LOGIN_TOOL = 'UserLoginTool';
  private readonly TOKEN_VALUE = 'tokenValue';
  private readonly ADMIN_TYPE_ID = 'adminTypeId';
  private readonly ADMIN_RETURN_URL = 'adminReturnUrl';
  private readonly ADMIN_FIRSTLASTNAME = 'AdminFirstLastName';
  private readonly ADMIN_COMPANYNAME = 'AdminCompanyName';
  private readonly ADMIN_USERACCESSIBLETOOLS='UserAccessibleTools';
  private readonly ADMIN_USERNAME='UserName';
  private readonly ADMIN_APPSTARTTIME='appStartTime';
  private readonly ADMIN_TOKENEXPIRYVALUE='tokenExpiryValue';

  // Set Values
  setAdminUserId(userId: number): void {
    localStorage.setItem(this.ADMIN_USER_ID, userId.toString());
  }

  setUserLoginTool(tool: string): void {
    localStorage.setItem(this.USER_LOGIN_TOOL, tool);
  }

  // Get Values
  getAdminUserId(): number {
    return +(localStorage.getItem(this.ADMIN_USER_ID) || 0);
  }

  getUserLoginTool(): string {
    return localStorage.getItem(this.USER_LOGIN_TOOL) || '';
  }

  getTokenValue(): string {
    return localStorage.getItem(this.TOKEN_VALUE) || '';
  }
  
  getAdminTypeId(): number {
    return +(localStorage.getItem(this.ADMIN_TYPE_ID) || 0);
  }

  getAdminFirstLastName(): string {
    return localStorage.getItem(this.ADMIN_FIRSTLASTNAME) || '';
  }

  getAdminCompanyName(): string {
    return localStorage.getItem(this.ADMIN_COMPANYNAME) || '';
  }

  getUserAccessibleTools(): string {
    return localStorage.getItem(this.ADMIN_USERACCESSIBLETOOLS) || '';
  }

  getUserName(): string {
    return localStorage.getItem(this.ADMIN_USERNAME) || '';
  }

  getAppStartTime(): string {
    return localStorage.getItem(this.ADMIN_APPSTARTTIME) || '';
  }

  getTokenExpiryValue(): string {
    return localStorage.getItem(this.ADMIN_TOKENEXPIRYVALUE) || '';
  }

  restoreAdminSessionFromLocalStorage(): void {
    const keys = [
      'AdminUserId', 'AdminUserType', 'AdminFirstLastName', 'AdminCompanyName',
      'adminTypeId', 'UserLoginTool', 'UserAccessibleTools',
      'tokenValue', 'tokenExpiryValue', 'appStartTime'
    ];

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const sessionVal = sessionStorage.getItem(key);
      if (!sessionVal || sessionVal === '') {
        const localVal = localStorage.getItem(key);
        if (localVal != null && localVal !== '') {
          sessionStorage.setItem(key, localVal);
        }
      }
    }
  }

  setAdminReturnUrl(url: string): void {
    if (url && url.trim() !== '') {
      sessionStorage.setItem(this.ADMIN_RETURN_URL, url.trim());
    }
  }

  getAdminReturnUrl(): string {
    return sessionStorage.getItem(this.ADMIN_RETURN_URL) || '';
  }

  clearAdminReturnUrl(): void {
    sessionStorage.removeItem(this.ADMIN_RETURN_URL);
  }
  // Remove
  removeAdminUserId(): void {
    sessionStorage.removeItem(this.ADMIN_USER_ID);
  }

  removeUserLoginTool(): void {
    sessionStorage.removeItem(this.USER_LOGIN_TOOL);
  }

  // Clear All
  clear(): void {
    sessionStorage.clear();
  }
}